import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addSbermarketProducts } from '../../../../actions/sbermarket';
import MarketBwhiteApi from '../../../../API/market/bwhite-api';
import { NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Select } from '../../../../components/Basic/Inputs';
import { MarketsFilter, MarketsSearch, MarketsTable } from '../../../../components/Markets';
import { FRONT_ERRORS, FRONT_WARNING } from '../../../../components/Markets/Blocks/Filter';
import { MARKET_MODES } from '../../../../constans';
import styles from './styles.module.scss';

const width = ['90px', '160px', '400px', '100px', '100px', '60px', '150px', '180px', '200px', '150px'];

const FILTER_MARKETPLACE = {
  0: 'all',
  1: 'instock',
  2: 'nullstock',
  3: 'stopbrand',
};

const BwhiteTable = ({
  isExpress = false,
  updateProviderStocksAndPrice = () => { },
  updateProviderPrice = () => { },
}) => {
  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [cards, setCards] = useState({ ids: [], byId: {} });

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ providerId: '' });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [error, setError] = useState(Object.keys(FRONT_ERRORS)[0]);
  const [warning, setWarning] = useState(Object.keys(FRONT_WARNING)[0]);

  const [productsSelect, setProductsSelect] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [errorsGroup, setErrorsGroup] = useState({});
  const [warningsGroup, setWarningsGroup] = useState({});
  const [contentMode, changeMode] = useState(MARKET_MODES[0]);

  const { role } = useSelector((store) => store.user);

  const dispatch = useDispatch();

  const onChangePage = (v) => {
    setPage(v);
  };

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      cards.ids.forEach((item) => {
        map_select[cards.byId[item].offer_id] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);
      setProductsSelect({});
    }
  };

  const changeProductSelect = (offer_id) => {
    if (productsSelect[offer_id]) {
      const s = productsSelect;
      delete s[offer_id];
      setProductsSelect({ ...s });
    } else {
      setProductsSelect({ ...productsSelect, [offer_id]: true });
    }
  };

  const params = useMemo(() => {
    return {
      search: search.trim(),
      limit: parseInt(show),
      shop: 'bwhite1',
      page,
      providerId: provider.id,
      tab: FILTER_MARKETPLACE[tab],
      filters: {
        errorType: error === 'null' ? null : error,
        warningType: warning === 'null' ? null : warning,
      },
    };
  }, [search, show, page, tab, provider.id, error, warning]);

  const loadCards = () => {
    MarketBwhiteApi.getCardsBySearch({ data: params }).then((r) => {
      const { allstock, instock, nullstock, stopbrand, archivestock } = r.stock;

      const byIds = {};
      const id = r.cards.map((item) => item.offer_id);
      r.cards.forEach((item) => (byIds[item.offer_id] = item));

      setCards({ byId: byIds, ids: id });
      setErrorsGroup(r.errorsGroup);
      setWarningsGroup(r.warningsGroup);

      setProductsSelect({});
      setCheckAll(false);
      setCountStock([allstock, instock, nullstock, stopbrand, archivestock]);

      setCount(r.stock.count);
    });

    return () => dispatch(addSbermarketProducts({ byId: {}, ids: [] }));
  };

  useEffect(() => {
    loadCards();
  }, [params]);

  const onChangeTab = (n) => {
    setTab(n);
  };

  const onChangeCard = async (offer_id, key, value) => {
    if (cards.byId[offer_id][key] === value) {
      return;
    }
    let setCard = (card) => {
      setCards({ ...cards, byId: { ...cards.byId, [offer_id]: card } });
    };

    if (key === 'stock') {
      return await MarketBwhiteApi.changeStock({ data: { shop: 'bwhite1', offer_id, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'price') {
      return await MarketBwhiteApi.changePrice({ data: { shop: 'bwhite1', offer_id, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }

    if (key === 'percent' || key === 'min_rub') {
      return await MarketBwhiteApi.changeMarginality({ data: { shop: 'bwhite1', offer_id, field: key, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketBwhiteApi.changeStopBrand({ data: { shop: 'bwhite1', offerIds: [offer_id], value } })
        .then((card) => {
          loadCards();
        })
        .catch((e) => console.log(e));
    }

    return await MarketBwhiteApi.changeCard({ data: { shop: 'bwhite1', offer_id, field: key, value } })
      .then((card) => {
        loadCards();
      })
      .catch((e) => console.log(e));
  };

  const onChangeCards = async (offerIds, key, value) => {
    if (key === 'stopbrand') {
      return await MarketBwhiteApi.changeStopBrand({ data: { shop: 'bwhite1', offerIds, value } })
        .then((card) => {
          loadCards();
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stock') {
      return await updateProviderStocksAndPrice(undefined, value, offerIds).then(() => {
        setCheckAll(false);
        setProductsSelect({});
      });
    }
    if (key === 'price') {
      return await updateProviderPrice(undefined, offerIds).then(() => {
        setCheckAll(false);
        setProductsSelect({});
      });
    }
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item['hide']);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', providerId: '' }, { name: 'Не заполнен', providerId: null }, ...p]);
      changeProvider({ name: 'Не выбран', providerId: '' });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = role === 'owner' || 'admin';
  return (
    <>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={['Все товары', 'В продаже', 'Готовы к продаже', 'Стоп бренды']}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />

          <div>
            <Select select={contentMode} list={MARKET_MODES} onSelect={(v) => changeMode(v)} width="150px" />
          </div>
        </Row>

        <MarketsSearch
          market={'KUPER'}
          selectTab={FILTER_MARKETPLACE[tab]}
          search={search}
          tab={tab}
          productsSelect={productsSelect}
          setSearch={setSearch}
          setCheckAll={setCheckAll}
          setProductsSelect={setProductsSelect}
          count={count}
          onArchive={(offerIds, state) => onChangeCards(offerIds, 'archive', state)}
          onStopbrand={(offerIds, state) => onChangeCards(offerIds, 'stopbrand', state)}
          updateStocks={(offerIds, state) => onChangeCards(offerIds, 'stock', state)}
          updatePrices={(offerIds) => onChangeCards(offerIds, 'price')}
        />

        <Row spaceBetween={true}>
          <MarketsFilter
            show={show}
            selectTab={FILTER_MARKETPLACE[tab]}
            provider={provider}
            providers={providers}
            error={error}
            setShow={setShow}
            setError={setError}
            setWarning={setWarning}
            changeProvider={changeProvider}
            errorsGroup={errorsGroup}
            warningsGroup={warningsGroup}
          />
        </Row>
      </WhiteBlock>

      <MarketsTable
        market={'B-WHITE'}
        contentMode={contentMode}
        checkAll={checkAll}
        clickCheckAll={clickCheckAll}
        tab={tab}
        isExpress={isExpress}
        isOwner={isOwner}
        cards={cards}
        count={count}
        show={show}
        page={page}
        selectTab={FILTER_MARKETPLACE[tab]}
        productsSelect={productsSelect}
        onChangePage={onChangePage}
        changeProductSelect={changeProductSelect}
        onChangeProduct={onChangeCard}
      />
    </>
  );
};

export default BwhiteTable;
